export default __webpack_public_path__ + "static/media/cloud.add8c297.png";